import HTTP from "../utils/HTTP";

class ImgUploadService {
  uploadImg = ({ image, folder, fileName }) => {
    return HTTP.post("/uploadImage", { image, folder, fileName });
  };

  deleteImg = (public_id, folder) => {
    return HTTP.post("/deleteImage", { public_id, folder });
  };
}

export default new ImgUploadService();
